module.exports = __webpack_public_path__ + "static/media/HERO.65761d8b.png";